export const RuntimeErrorHandler = {
  hadRuntimeError: false,
}
